import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ptg-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
